import VTooltip from 'v-tooltip'

export default (Vue) => {
  Vue.use(VTooltip, {
    // defaultContainer: '.box-body'
  })
}
